export const Config = {
  main_url: 'https://attendance-api.ashwayanarealitygroup.com',
  mainpy_url: 'https://attendance-python.ashwayanarealitygroup.com',
};
